module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "4px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "4px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Anchor Bible")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("AcBib")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Academia biblica")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Aram.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Aramaic")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("BibInt")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Biblical Interpretation")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("BSac")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Bibliotheca sacra")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("BST")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("The Bible Speaks Today")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("BZ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Biblische Zeitschrift")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("BZAW")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("BZNW")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("CR:BS")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Currents in Research: Biblical Studies")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ErIsr")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Eretz-Israel")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("FAT")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Forschungen zum Alten Testament")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("FOTL")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Forms of the Old Testament Literature")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Hebr.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Hebrew")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("JSNTSup")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Journal for the Study of the New Testament, Supplement Series")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("JSOTSup")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Journal for the Study of the Old Testament, Supplement Series")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("LNTS")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Library of New Testament Studies")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LXX")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("MNTS")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("McMaster New Testament Studies")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Masoretic Text")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NAC")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New American Commentary")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NASB")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New American Standard Bible")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NICOT")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New International Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_c('i', [_vm._v("NIDNTT")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("New International Dictionary of New Testament Theology")]), _vm._v(", ed. C. Brown, 3 vols., Exeter: Paternoster, 1975, 1976, 1978")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("NIDOTTE")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("New International Dictionary of Old Testament Theology and Exegesis")]), _vm._v(", ed. W. A. VanGemeren, 5 vols., Carlisle: Paternoster; Grand Rapids: Zondervan, 1996")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NIV")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NIVAC")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New International Version Application Commentary")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NJPSV")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Jewish Publication Society Version")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NRSV")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NSBT")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("OBT")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Overtures to Biblical Theology")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("OG")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Old Greek")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("OTL")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Old Testament Library")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("OTM")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Old Testament Message")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Revue biblique")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("RevExp")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Review and Expositor")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SBLAB")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Society of Biblical Literature Academia Biblica")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SBLEJL")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Society of Biblical Literature Early Judaism and Its Literature")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("SBLSP")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Society of Biblical Literature Seminar Papers")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SBLSymS")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Society of Biblical Literature Symposium Series")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SBT")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SHBC")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Smyth & Helwys Bible Commentary")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SHS")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Scripture and Hermeneutics Series")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SJLA")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Studies in Judaism in Late Antiquity")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("STDJ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Studies on the Texts of the Desert of Judah")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("STI")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Studies in Theological Interpretation")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(", ed. G. Kittel and G. Friedrich, tr. G. W. Bromiley, 10 vols., Grand Rapids: Eerdmans, 1964–76")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("TLNT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Theological Lexicon of the New Testament")]), _vm._v(", ed. C. Spicq, tr. and ed. J. D. Ernest, 3 vols., Peabody: Hendrickson, 1994")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("TLOT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Theological Lexicon of the Old Testament")]), _vm._v(", ed. E. Jenni and C. Westermann, 3 vols., Peabody: Hendrickson, 1997")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("TNTC")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Tyndale New Testament Commentaries")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("tr.")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("translation, translated, translated by")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("TWOT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Theological Wordbook of the Old Testament")]), _vm._v(", ed. R. L. Harris, G. L. Archer Jr. and B. K. Waltke, 2 vols., Chicago: Moody, 1980")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("TynB")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("VTSup")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Supplements to Vetus Testamentum")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("WTJ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Westminster Theological Journal")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "4px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 75
// module chunks = 0